import React from 'react';
import { Switch as AntSwitch } from 'antd';
import type { SwitchProps } from 'antd';
import clsx from 'clsx';

/**
 * Thin wrapper over the Antd Switch (per the antd wrapper standardization plan):
 * single import source through @common/components and a `wk-switch` class hook.
 */
export const Switch = ({ className, ...props }: SwitchProps) => (
  <AntSwitch {...props} className={clsx('wk-switch', className)} />
);
